import React, { useEffect } from 'react';
import { Box, Container, Divider, makeStyles } from '@material-ui/core';
import { useMaintenancePackage } from 'src/hooks/useMaintenancePackage';
import { useTranslation } from 'react-i18next';
import useAuth from 'src/hooks/useAuth';
import Page from 'src/components/Page';
import useStore from 'src/hooks/useStore';
import { Header } from 'src/components/Headers';
import { MaintenancePackage } from 'src/constants/modules/maintenancePackage';
import { MAINTENANCE_PACKAGE_AUTH } from 'src/constants/permissions';
import { IMaintenancePackage } from 'src/interfaces/maintenancePackage';
import { useHistory } from 'react-router-dom';
import { MaintenancePackageForm } from 'src/components/MaintenancePackages/Forms/components';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
}));

export const CreateMaintenancePackage = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { user } = useAuth();
    const { createMaintenancePackage } = useMaintenancePackage();
    const { getStores } = useStore();
    const history = useHistory();

    useEffect(() => {
        if (user._id) getStores();
    }, [user]);

    const handleSubmit = async (values: Partial<IMaintenancePackage>) => {
        const response = await createMaintenancePackage(values, {
            select: '_id',
        });
        if (response?._id)
            history.push(`/management/maintenance-packages/${response._id}`);
    };

    return (
        <Page className={classes.root} title={t('maintenancePackage.Create')}>
            <Container maxWidth="lg">
                <Header
                    module={MaintenancePackage.name}
                    route={MaintenancePackage.route}
                    crud={{
                        goBack: true,
                    }}
                    permission={MAINTENANCE_PACKAGE_AUTH}
                />
                <Divider />
                <Box mt={3}>
                    <MaintenancePackageForm
                        mode="create"
                        onSubmit={handleSubmit}
                    />
                </Box>
            </Container>
        </Page>
    );
};
